import { getCoreRowModel } from "@tanstack/react-table"
import type { OnChangeFn, SortingState } from "@tanstack/react-table"
import type { FC } from "react"

import { useApAgingInvoiceColumns } from "../hooks/useApAgingInvoiceColumns"
import type { ApAgingInvoice } from "../types/apAgingReport"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"

interface ApAgingInvoiceTableProps {
  vendorCompanyId: string
  data: ApAgingInvoice[]
  sorting: SortingState
  onSortingChange: OnChangeFn<SortingState>
}

// AK-6964 AC6: The invoices contributing to the vendor's totals. Sorting only reorders rows; the backend returns the
// same invoices and totals whatever the order.
export const ApAgingInvoiceTable: FC<ApAgingInvoiceTableProps> = ({
  vendorCompanyId,
  data,
  sorting,
  onSortingChange,
}) => {
  const columns = useApAgingInvoiceColumns()
  return (
    <AerosBaseTable<ApAgingInvoice>
      slotProps={{
        headerCell: { className: "bg-white whitespace-nowrap" },
        bodyCell: { className: "whitespace-nowrap tabular-nums" },
        container: {
          ...({ "data-testid": `ap-aging-report.invoices-table.table-${vendorCompanyId}` } as Record<string, string>),
        },
      }}
      features={{
        tanstackOptions: {
          data,
          columns,
          state: { sorting },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          getRowId: (invoice) => invoice.invoiceId,
          onSortingChange,
        },
      }}
      noDataMessage='No invoices found'
    />
  )
}
